import { render, staticRenderFns } from "./VerificationModal.vue?vue&type=template&id=a1b0d90e&scoped=true&"
import script from "./VerificationModal.vue?vue&type=script&lang=ts&"
export * from "./VerificationModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationModal.vue?vue&type=style&index=0&id=a1b0d90e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b0d90e",
  null
  
)

export default component.exports